module.exports = __webpack_public_path__ + "static/media/inf_21pog26p.1647b238.mp3";